<docs>
# SEO

SEO component, data is fetched from store and it will update everything by itself.
all the magic will happen inside the SEOStore.

</docs>

<script lang="ts">
import { useHead } from '@vueuse/head';
import { store as SEOStore } from 'plugins/seo/store';
import { defineComponent, toRefs } from 'vue';

const SEO = defineComponent({
  name: "SEO",
  setup(){
    const { metadata } = toRefs(SEOStore.state);
    
    useHead(metadata);

    return {
      seo: metadata,
    }
  },
});
export default SEO

</script>

<template>
  <slot />
</template>
